import PropTypes from 'prop-types'
import { Element } from '../../../../../common/html/element'
import classes from './index.module.scss'

const TooltipExpression = ({ expressions, style }) => {
  return (
    <Element
      className="dFlex alignItemsCenter"
      style={{ color: '#ECECEC', ...style }}
    >
      {expressions.map(
        (
          { text, operator, isDivide, textUnder, styleContainer, styleText },
          index,
        ) => {
          return (
            <div
              style={styleContainer}
              className="dFlex alignItemsCenter"
              key={index}
            >
              <div className={index ? classes.ml6 : undefined}>
                <div style={styleText} className={classes.textCenter}>
                  {text}
                </div>
                {isDivide && (
                  <>
                    <Element
                      style={{ backgroundColor: '#ECECEC' }}
                      className={classes.operatorDivide}
                    />
                    <div className={classes.textCenter}>{textUnder}</div>
                  </>
                )}
              </div>
              <div className={classes.ml6}>{operator}</div>
            </div>
          )
        },
      )}
    </Element>
  )
}

TooltipExpression.propTypes = {
  expressions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.node,
      ]),
      operator: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.node,
      ]),
      isDivide: PropTypes.bool,
      textUnder: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.node,
      ]),
      styleContainer: PropTypes.object,
      styleText: PropTypes.object,
    }),
  ),
  style: PropTypes.object,
}

TooltipExpression.defaultProps = {
  expressions: [],
  style: {},
}

export default TooltipExpression
